import { Injectable, inject } from '@angular/core';
import { HttpMiddlewareService } from '../../admin/_services/http/http-middleware.service';
import { Globals } from '../../admin/globals.service';
import { SyncVehicleTypeData } from 'src/app/typescript/syncVehicleTypeData';
import { VehiclePublicModel } from 'src/app/typescript/vehiclePublicModel';
import { SyncedVehicleTypes } from 'src/app/typescript/syncedVehicleTypes';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class VehicleService {
  private http = inject(HttpMiddlewareService);
  private globals = inject(Globals);

  ENDPOINT = '/public/api/vehicle';
  constructor() {
    this.http
      .post(this.globals.baseUrl + '/public/api/common/syncVehicleTypes', { date: new Date(1970, 1, 1) })
      .subscribe((ok: SyncedVehicleTypes) => {
        this.syncedVehicles.next(ok);
      });
  }

  syncedVehicles: BehaviorSubject<SyncedVehicleTypes> = new BehaviorSubject<SyncedVehicleTypes>({
    createdOrModifiedVehicleTypes: null,
    deletedIds: null,
    refreshDate: null,
  });

  syncVehicles(date: SyncVehicleTypeData): BehaviorSubject<SyncedVehicleTypes> {
    return this.syncedVehicles;
  }

  registerVehicle(vehicle: VehiclePublicModel) {
    return this.http.post(this.globals.baseUrl + this.ENDPOINT, vehicle);
  }

  patchVehicle(vehicle: VehiclePublicModel) {
    return this.http.patch(this.globals.baseUrl + this.ENDPOINT + '/' + vehicle.id, vehicle);
  }

  deleteVehicle(vehicleId: string) {
    return this.http.delete(this.globals.baseUrl + this.ENDPOINT + '/' + vehicleId);
  }

  getVehicletyresInWorkshop(vehicleId: number, workshopId: number) {
    return this.http.get(this.globals.baseUrl + this.ENDPOINT + '/' + vehicleId + '/tyres?workshopId=' + workshopId);
  }

  getWorkLogs(vehicleId: number) {
    return this.http.get(this.globals.baseUrl + this.ENDPOINT + `/${vehicleId}/digitalworklogs`);
  }

  downloadWorkLog(vehicleId: number, worklogId: number) {
    return this.http.getFile(
      this.globals.baseUrl + this.ENDPOINT + `/${vehicleId}/digitalworklogs/${worklogId}/export`
    );
  }

  getVehicleTyres(vehicleId: number) {
    return this.http.get(this.globals.baseUrl + this.ENDPOINT + `/${vehicleId}/workShopTyres`);
  }

  getStoredTyreLabel(vehicleId: number) {
    return this.http.getFile(this.globals.baseUrl + this.ENDPOINT + `/${vehicleId}/tyreHotelService/storedTyreLabel`);
  }
}
